export default "__VITE_ASSET__Dclt2t71__"